import promise from 'es6-promise';
promise.polyfill();
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// 引入路由
import router from './router'
// 导入 JS 公共方法
import commTools from './tools/common.js' 
// 引入 封装的axios 的 http 请求
import http from'./http/http_axios.js' 
// 引入公共样式
import './assets/css/comment.css' 
/************* 插件的引用 **************** */  
//引入时间控件的引用
import './assets/js/laydate.js'
import './assets/js/theme/default/laydate.css'
//swiper 的引用
import swiper from 'swiper'
import 'swiper/dist/css/swiper.css';
//引入 echarts 
import echarts from 'echarts'
//引入动画库
import './assets/css/animate.css' 
//引入 vant 组件
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
// 引入 element-ui 组件
import './element/element' 
/************* 加密相关 **************** */ 
//RSA 加密
import JsEncryptVue from 'jsencrypt'
//RSA 加密 of jsrsasign
import jsrsasign from  'jsrsasign'
// ASE 加密
import cryptoJS from 'crypto-js/crypto-js'
//导入转换图片的 工具
import domtoimage from 'dom-to-image'
//MD5
import md5Tools from './tools/md5.js'

import './assets/css/fonts-new-burt/iconfont.css'
import './assets/css/fonts-new-burt/iconfont.woff'
Vue.use(Vant);
//时间控件
import moment from 'moment/moment'
Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
  return moment(value).format(formatString);
});
 
//将 axios 改写为 Vue 的原型属性，其他圆形组件也可以使用了
Vue.prototype.$axios_get = http.axios_get;
Vue.prototype.$axios_post = http.axios_post;
Vue.prototype.$axios_uploader = http.axios_uploader;
Vue.prototype.$axios_all = http.axios_all;
Vue.prototype.$axios_post_kf = http.axios_post_kf;
Vue.prototype.$axios_uploader_kf = http.axios_uploader_kf;
//把swiper添加至 vue 原型里
Vue.prototype.$swiper = swiper; 
//把swiper添加至 vue 原型里
Vue.prototype.$echarts = echarts; 
//使用图片转换工具
Vue.prototype.$domtoimage = domtoimage;
//把公用方法添加到vue原型里
Vue.prototype.$tools= commTools;
//把RSA加密vue原型里
Vue.prototype.$jsEncrypt = JsEncryptVue;
//把RSA加密 of jsrsasign vue原型里
Vue.prototype.$jsrsasign = jsrsasign;
//把AES加密vue原型里
Vue.prototype.$cryptoJS = cryptoJS;
//MD5
Vue.prototype.$MD5 = md5Tools;
//关闭控制台的提示
Vue.config.productionTip = false;

//*******使用  require.context 全局注册组件 自动化组件***********************************************/
//-- 获得所有的的 公用组件
let requireComponent = require.context('./components/BaseCpts', false, /\.vue$/);
//-- 配置所有的 公用组件
requireComponent.keys().forEach( fileName =>{	
	//-- 获得组件配置
	let componentConfig = requireComponent(fileName);
	//-- 获取组件的 PascalCase 命名
	let componentName = upperFirst(
		//剥去文件名开头的'./'和结尾的扩展名
		camelCase( fileName.replace(/^\.\/(.*)\.\w+$/, '$1') )
	)
	//-- 全局注册组件
    Vue.component(
    	componentName,
	    //-- 如果这个组件选项是通过 `export default` 导出的，那么就会优先使用 `.default`， 否则回退到使用模块的根。
	    componentConfig.default || componentConfig
    )
})

// 注册一个全局自定义指令 v-focus
Vue.directive('thousandth', {
  bind(el, binding, vnode) { 
    if(vnode.data.attrs.type&&vnode.data.attrs.type == 'money'){

      el.addEventListener('blur',event=>{  
        el.setAttribute("class",'blur');
        vnode.context.$nextTick(() => event.target.value = Separator(event.target.value))     
      })
      el.addEventListener('focus',event=>{
        el.setAttribute("class",'focus');
        vnode.context.$nextTick(() => event.target.value = event.target.value.replace(/,/g, ""))  
      })
    }     
    // 处理千分位展示
    const Separator = (num) => {
      let num1 = num.split(".")[0], num2 = num.split(".")[1];
      let c = num1.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return num.toString().indexOf(".") !== -1 ? c + "." + num2 : c;
    }
  }  
})

/* eslint-disable no-new */
new Vue({
  	el: '#app',
	router,
	store,
  	template: '<App/>',
    components: { App },
    data(){
        return{
            currentRoute:'' //-- 当前路由
        }
    },    
	mounted(){  
        commTools.watchRouter(this.$router.currentRoute.path.toLowerCase(),router);   
    },  
	//可检测路由变化
	watch:{
  		//$router(routerStr,router){ 
            //console.log(routerStr,router);
            //设置页面的 滚动的事件(默认否是页面最顶端)
            //commTools.setScroll();
            //检测是不是可以跳转
            //commTools.watchPouterIsPass(routerStr.path,router);
            //console.log('router',routerStr,router)
        //}, 
	}
})
 
//路由跳转 前 拦截 ***************************************************************/
router.beforeEach((to, from, next) => {  
	//设置页面访问权限
	if(commTools.watchRouter(to.path.toLowerCase(),router,from.path)){ 
		next(); //可执行当前路由
	}
});  
//路由跳转 后 拦截 ***************************************************************/
router.afterEach((to,form)=>{
    let tmpRouter = '';
    // 供下个页面依赖用时,有需要直接 更新 至 state 的(考虑到地址栏可以输入地址)
    // 有的需要在跳转时 更新 至 state
    ['/fundslist'].map((item,index) => {
        to.path == item ? tmpRouter = item : '';
    })
    if(!tmpRouter && form.path != '/'){
        tmpRouter = form.path;
    }
    if(tmpRouter){
        //记录当前路由,供下个页面依赖用
        store.commit('upRelyOnRouter',tmpRouter.toLowerCase());
    }
    //设置页面的 滚动的事件(默认否是页面最顶端)
    commTools.setScroll();
    //检测是不是可以跳转
    commTools.watchPouterIsPass(to.path.toLowerCase(),form);
})
 


// WEBPACK FOOTER //
// ./src/main.js